/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Active_HintInputs */

const vi_irrigation_schedule_active_hint = /** @type {(inputs: Irrigation_Schedule_Active_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật để hệ thống tự bật/tắt bơm theo lịch này. Tắt thì cấu hình vẫn được giữ, không phải nhập lại.`)
};

/**

* @param {Irrigation_Schedule_Active_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_active_hint = /** @type {((inputs?: Irrigation_Schedule_Active_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Active_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_active_hint(inputs)
});